<div class="modal" [ngClass]="{'show': show}">
    <div class="modal-body">
        <button class="btn btn-secondary btn-rounded modal-close" (click)="close()">
            <span class="icon-close"></span>
        </button>
        <ng-content></ng-content>
    </div>
</div>
<div class="modal-background" [ngClass]="{'show': show}"></div>